import axios from 'axios';

export const ModulesService = {
  async getModules({ page, perPage }) {
    const res = await axios.get('rbac/v1/modules/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },

  async createModule(data) {
    const res = await axios.post('rbac/v1/modules/', data);

    if (res.status === 201) {
      return true;
    }

    return Promise.reject();
  },

  async editModule(data, id) {
    const res = await axios.put(`rbac/v1/modules/${id}/`, data);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async deleteModule(id) {
    const res = await axios.delete(`rbac/v1/modules/${id}/`);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
